import EasterEggs from "./EasterEggs"
import Floor from "./Floor"
import Lights from "./Lights"
import Poster from "./Poster"
import WallThickness from "./WallThickness"
import Walls from "./Walls"

export default function Room()
{
    return <>
        <Walls />
        <Floor />
        <Lights />
        <WallThickness />
        <EasterEggs />
    </>
}